"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalLinksAndLogos = void 0;
const classnames_1 = __importDefault(require("classnames"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const FooterLink_atom_1 = require("../atoms/FooterLink.atom");
const PropertyLogos_molecule_1 = require("./PropertyLogos.molecule");
const Styled = styled_components_1.default.div `
	display: flex;
	align-items: stretch;
	justify-content: space-between;

	&.ar {
		.legal-links {
			margin-left: 100px;
			margin-right: initial;
			${(p) => p.theme.breakpoints.down("sm")} {
				margin-left: 0px;
			}
		}
	}

	.legal-links {
		.footer-link:first-child {
			padding-left: 0;
		}
	}

	${(p) => p.theme.breakpoints.down("sm")} {
		display: block;
		text-align: center;

		.legal-links {
			margin-right: 0;
			margin-top: 32px;
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.footer-link {
			text-align: center;
			padding: 4px;
		}
	}
`;
const LegalLinksAndLogos = ({ locale, hideDefaultTermsPolicy, moreLegalLinks = [], logos = [], epicLogoConfig, }) => {
    const { messages } = (0, shared_1.useMessages)();
    const isLegacyLinkBehaviour = (0, epic_games_nav_shared_1.useLegacyLinkBehaviour)();
    return (react_1.default.createElement(Styled, { className: (0, classnames_1.default)(locale) },
        react_1.default.createElement("div", { className: "legal-links" },
            !hideDefaultTermsPolicy ? (isLegacyLinkBehaviour ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(FooterLink_atom_1.FooterLink, { id: "footerTerms", title: messages.tos, href: `https://www.epicgames.com/${locale}/tos?lang=${locale}` }),
                react_1.default.createElement(FooterLink_atom_1.FooterLink, { id: "footerPrivacy", title: messages.privacy, href: `https://www.epicgames.com/${locale}/privacypolicy?lang=${locale}` }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(FooterLink_atom_1.FooterLink, { id: "footerTerms", title: messages.tos, hrefTemplate: `https://www.epicgames.com/${locale}/tos?lang=${locale}` }),
                react_1.default.createElement(FooterLink_atom_1.FooterLink, { id: "footerPrivacy", title: messages.privacy, hrefTemplate: `https://www.epicgames.com/${locale}/privacypolicy?lang=${locale}` })))) : null,
            moreLegalLinks.map((legalLink) => {
                return react_1.default.createElement(FooterLink_atom_1.FooterLink, Object.assign({ key: legalLink.title }, legalLink));
            })),
        react_1.default.createElement(PropertyLogos_molecule_1.PropertyLogos, { logos: logos, locale: locale, epicLogoConfig: epicLogoConfig })));
};
exports.LegalLinksAndLogos = LegalLinksAndLogos;
//# sourceMappingURL=LegalLinksAndLogos.molecule.js.map